<template >
  <div>
    <svg class="display-none">
      <defs>
        <pattern
          v-for="item in colors.camos"
          :key="generateId(item)"
          :id="item.name"
          patternContentUnits="objectBoundingBox"
          height="100%"
          width="100%"
        >
          <image
            height="1"
            width="1"
            preserveAspectRatio="none"
            v-bind:xlink:href="getSvgUrl(item.name,'camos')"
          />
        </pattern>
        <pattern
          v-for="item in colors.prints"
          :key="generateId(item)"
          :id="item.name"
          patternContentUnits="objectBoundingBox"
          height="100%"
          width="100%"
        >
          <image
            height="1"
            width="1"
            preserveAspectRatio="none"
            v-bind:xlink:href="getSvgUrl(item.name,'prints')"
          />
        </pattern>
      </defs>
    </svg>
    <v-card>
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex xs10 sm6 md4 lg3 v-for="item in order.contact" :key="item.id" class="px-2">
            <v-text-field
              readonly
              box
              :title="item.title"
              :label="item.label+':'"
              class="measurements-input"
              type="text"
              :id="item.label"
              :name="item.label"
              v-model="item.value"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-btn @click="deleteOrder" color="error">Delete order (can't be undone)</v-btn>
    <v-card
      flat
      class="my-4 pa-3"
      color="grey lighten-2"
      v-for="suit in order.orders"
      :key="suit.charge"
    >
      <Preview :order="suit" :admin="true" />
    </v-card>
  </div>
</template>

<script>
import Preview from "@/components/OverView";
import { db } from "../firebase";
import { mixin } from "@/mixins/index.js";
export default {
  data() {
    return {
      order: []
    };
  },
  components: {
    Preview
  },
  mixins: [mixin],
  computed: {
    colors() {
      return this.$store.getters.colors;
    }
  },
  methods: {
    getImgUrl(name) {
      return require("../assets/camos/" + name + ".jpg");
    },
    deleteOrder() {
      console.log(this.$route.params.id);
      let id = this.$route.params.id;
      db.collection("orders")
        .doc(id)
        .delete()
        .then(() => {
          this.$router.go(-1);
        })
        .catch(error => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    let url = this.$route.params.id;
    db.collection("orders")
      .doc(url)
      .get()
      .then(item => {
        this.order = item.data().order;
      });
  },
};
</script>


